import { format, utcToZonedTime } from 'date-fns-tz'

export const formatInTimeZone = (date: Date | string, fmt: string, tz: string) =>
  format(utcToZonedTime(date, tz), fmt, { timeZone: tz })
